import { z } from 'zod';

// Taxonomía de tags de caché. Única fuente de verdad para la web
// (`next.tags` / `revalidateTag`) y para la API (qué purgar tras una
// escritura del admin o un webhook del Core). Ver el proyecto
// "Cache strategy + invalidate cache for all admin content" en Linear.

// Tags gruesas: una por superficie/colección de recursos. Purgar una
// invalida todas las páginas de la web que la consumen.
export const CACHE_TAG_EVENTS = 'events';
export const CACHE_TAG_COLLECTIONS = 'collections';
export const CACHE_TAG_HOME = 'home';
export const CACHE_TAG_BLOG = 'blog';
export const CACHE_TAG_SEARCH_CHIPS = 'search-chips';
export const CACHE_TAG_ARTISTS = 'artists';
export const CACHE_TAG_CITIES = 'cities';

// Lista de todas las tags gruesas. La usa la purga manual del admin
// ("vaciar todo") y sirve de allowlist para validar el `scope` entrante.
export const COARSE_CACHE_TAGS = [
  CACHE_TAG_EVENTS,
  CACHE_TAG_COLLECTIONS,
  CACHE_TAG_HOME,
  CACHE_TAG_BLOG,
  CACHE_TAG_SEARCH_CHIPS,
  CACHE_TAG_ARTISTS,
  CACHE_TAG_CITIES,
] as const;

export type CoarseCacheTag = (typeof COARSE_CACHE_TAGS)[number];

export function isCoarseCacheTag(value: string): value is CoarseCacheTag {
  return (COARSE_CACHE_TAGS as readonly string[]).includes(value);
}

// Builders granulares. Usan prefijos distintos para id y slug para que
// no haya ambigüedad: un evento se cachea por id (colecciones/home, vía
// `getEventsByIds`) y por slug (ficha de detalle, `/v1/event/by-slug`).
export const eventTag = (id: string): string => `event:${id}`;
export const eventSlugTag = (slug: string): string => `event-slug:${slug}`;
export const collectionTag = (slug: string): string => `collection:${slug}`;
export const blogTag = (slug: string): string => `blog:${slug}`;
export const artistTag = (id: string): string => `artist:${id}`;

// Purga manual del admin (página Configuración). `scope` = `all` (todas
// las tags gruesas) o una superficie concreta. Tupla literal explícita
// para que `z.enum` infiera bien los valores.
export const CACHE_PURGE_SCOPES = [
  'all',
  CACHE_TAG_EVENTS,
  CACHE_TAG_COLLECTIONS,
  CACHE_TAG_HOME,
  CACHE_TAG_BLOG,
  CACHE_TAG_SEARCH_CHIPS,
  CACHE_TAG_ARTISTS,
  CACHE_TAG_CITIES,
] as const;

export const CachePurgeScopeSchema = z.enum(CACHE_PURGE_SCOPES);
export type CachePurgeScope = z.infer<typeof CachePurgeScopeSchema>;

export const CachePurgeInputSchema = z.object({ scope: CachePurgeScopeSchema });
export type CachePurgeInput = z.infer<typeof CachePurgeInputSchema>;
